import {connect} from '@modifi/redux'

import {CurrencyVal, Currency} from '@modifi/enums'

import ExpectedFinancingLimit, {ExpectedFinancingLimitType} from './ExpectedFinancingLimit'

import {selectCurrencyConversionRate, aFetchAllExchangeRates} from '../../../../data/exchange-rate'

const mapStateToProps = (
  state: Record<string, any>
): Pick<ExpectedFinancingLimitType, 'getConversionRate'> => ({
  getConversionRate: (expectedFinancingLimitCurrency: CurrencyVal): number =>
    selectCurrencyConversionRate(state, expectedFinancingLimitCurrency, Currency.USD),
})

const mapDispatchToProps = {
  fetchAllExchangeRates: aFetchAllExchangeRates,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpectedFinancingLimit)
